import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AboutUsComponent } from './about-us/about-us.component';
import { Router, NavigationEnd, ActivatedRoute, RouterEvent } from '@angular/router';
import { filter, mergeMap, startWith, map } from 'rxjs/operators';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Location } from '@angular/common';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UsersType } from 'src/app/utilities/common-file';
import { UserIdleService } from 'angular-user-idle';
import { AuthRoutes, AuthRoutesIn } from 'src/app/utilities/routes';
import { AngularFirestore } from '@angular/fire/firestore';
import { NotificationsComponent } from './notifications/notifications.component';
import { BehaviorSubject } from 'rxjs';
import { Messages } from 'src/app/utilities/message';
import { OrdersService } from 'src/app/orders/orders.service';
import { RolesService } from 'src/app/roles/roles.service';


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.less']
})
export class AccountComponent implements OnInit {

  private displayName: string;
  hideScroll = false;
  isCollapsed = true;
  title = '';
  isAboutOpen = false;
  iconName = 'dashboard';
  isMainModule = true;
  selectedUserId: number;
  visible = false;
  showSettlements = false;
  loginUserType = '';
  currentUrl: string;
  // For drawer Close on Logout
  notifyLogout: any;
  newMessageCount = 0;
  userNotificationTime: any;
  currentMessage = new BehaviorSubject(null);
  pushNotification: any;
  isLoading = true;


  constructor(private drawerService: NzDrawerService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private _location: Location, private userIdle: UserIdleService, private notification: NzNotificationService,
    private modalService: NzModalService,
    private authService: AuthService,
    private firestore: AngularFirestore,
    private orderService : OrdersService,
    private roleService: RolesService) {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!this.authService.getAuthToken()) {
          const url = event.url.split('/')[1];
          if (AuthRoutesIn.includes(url)) { //if authoutes we dont need to toute
          } else {
            this.router.navigate([AuthRoutes.login]);
            notification.error('error', Messages.sessionExpired, { nzKey: 'key' });
          }
        }
      }
    })

    this.notifyLogout = this.authService.notify.subscribe((result) => {
      if (result) {
        this.router.events.subscribe((e: RouterEvent) => {
          this.currentUrl = e.url;
          if (this.currentUrl !== AuthRoutes.login) {
            this.modalService.closeAll();
          }
        });
        this.userIdle.stopTimer();
        this.userIdle.stopWatching();
        this.userIdle.resetTimer();
      }
    });
        // To Clear accessModuleList
        this.authService.clearDecryptModules();
        this.getRoleDetails();
  }
  // To get Login User's Role details and Store it as encrypted value in local storage
  getRoleDetails() {
    this.roleService.getRoleDetailsById().subscribe((response: any) => {
      if (response.data.backofficeUserRoleDetails) {
        this.isLoading = false;
        if (response.data.backofficeUserRoleDetails.length > 0) {
          this.authService.setRoleAccessModule((JSON.stringify(response.data.backofficeUserRoleDetails)).toString());
          this.authService.getDecryptModules();
        } else {
          this.authService.setRoleAccessModule((JSON.stringify([])).toString());
          this.authService.getDecryptModules();
        }
      } else {
        this.authService.setRoleAccessModule((JSON.stringify([])).toString());
        this.authService.getDecryptModules();
      }
    }, error => {
      this.isLoading = false;
      if (error.error.message === Messages.noData) {
        this.authService.setRoleAccessModule((JSON.stringify([])).toString());
        this.authService.getDecryptModules();
      }
    });
  }

  getModuleGroup(groupName: string) {
    return this.authService.getModuleGroup(groupName);
  }
  
    // To Show / Hide group based on Login User's Role
    getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
      return this.authService.getModuleGroupAndModuleAccess(moduleName, groupName);
    }

  ngOnInit() {
    this.selectedUserId = this.authService.getUserId();
    this.router.events.subscribe((e: RouterEvent) => {
      this.currentUrl = e.url;
    });
    this.getCountForNotifications();
    this.pushNotification = this.currentMessage;
    this.userIdle.resetTimer();
    this.userIdle.startWatching();
    this.userIdle.onTimerStart().subscribe(count => {
      this.userIdle.onTimeout().subscribe(countForTimeout => {
        if (this.currentUrl !== AuthRoutes.login) {
          this.showActionConfirm();
        }
      });
    });
    this.getUserDisplayName();

    this.loginUserType = this.authService.getRole();
    this.showSettlements = this.authService.showOptionsBasedOnUserType();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd),
        startWith(this.activatedRoute),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        if (data.title) {
          this.title = data.title;
          if (this.title === 'Dashboard' || this.title === 'Transactions' || this.title === 'Reports' || this.title === 'Settings' || this.title === 'Settlements' || this.title === 'Merchant Orders' || this.title ==='Products' || this.title ==='Vouchers' || this.title ==='Payments') {
            this.iconName = this.title;
            this.isMainModule = true;
          } else {
            this.iconName = 'back';
            this.isMainModule = false;
          }
        }
      });
  }
  getUserDisplayName() {
    this.displayName = this.authService.getDisplayName();
  }
  logout() {
    this.notification.info('Please Wait', '', {
      nzKey: 'key'
    });
    this.orderService.clearCartAction(false)
    this.authService.logout().subscribe((response: any) => {
       this.userIdle.stopWatching();
      this.notification.success(response.message, '', {
        nzKey: 'key'
      });
    }, err => {

    });
  }
  aboutUs() {
    if (this.isAboutOpen === true) { return; }
    this.isAboutOpen = true;
    const drawerRefCreate = this.drawerService.create<AboutUsComponent, string>({
      nzContent: AboutUsComponent,
      nzWidth: '700px',
      nzClosable: true,
      nzOffsetX: this.isCollapsed ? 60 : 192,
      nzPlacement: 'left',
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      },
      nzMaskStyle: {
        'margin-left': '60px'
      }
    });
    drawerRefCreate.afterClose.subscribe(data => {
      this.isAboutOpen = false;
      if (data && typeof data !== null) {
      }
    });
  }
  updateProfile(): void {
    const drawerRefCreate = this.drawerService.create<UpdateProfileComponent, { selectedUserId: number }, string>({
      nzTitle: this.authService.getDisplayName(),
      nzContent: UpdateProfileComponent,
      nzWidth: '700px',
      nzClosable: true,
      nzContentParams: {
        selectedUserId: this.selectedUserId,
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    // For drawer Close on Logout
    drawerRefCreate.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefCreate.close();
        }
      });
    });
    drawerRefCreate.afterClose.subscribe(res => {
      this.visible = false;
      if (res && typeof res !== null) {
        this.userIdle.stopWatching();
      }
    });
  }
  changePassword() {
    const drawerRefCreate = this.drawerService.create<ChangePasswordComponent, string>({
      nzTitle: 'Change Password',
      nzContent: ChangePasswordComponent,
      nzWidth: '500px',
      nzClosable: true,
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      },
    });
    // For drawer Close on Logout
    drawerRefCreate.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefCreate.close();
        }
      });
    });
    drawerRefCreate.afterClose.subscribe(data => {
      this.visible = false;
      this.userIdle.stopWatching();
      if (data && typeof data !== null) {
      }
    });
  }
  backClicked() {
    this._location.back();
  }
  showActionConfirm(): void {
    this.userIdle.stopWatching();
    this.modalService.success({
      nzTitle: 'The session has idle since 1 hour. Do you want to logout or keep login ?',
      nzOkText: 'Logout',
      nzCancelText: 'Keep me Logged In',
      nzMaskStyle: {
        background: 'rgba(0, 0, 0, 0.05)'
      },
      nzOnCancel: () => this.cancelEvent(),
      nzOkType: 'danger',
      nzOnOk: () => this.stopWatching()
    });

  }
  stopWatching() {
    this.userIdle.stopWatching();
    this.authService.onNotify(true);
    this.modalService.closeAll();
    this.authService.logout();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
  cancelEvent() {
    this.modalService.closeAll();
    this.userIdle.resetTimer();
    this.userIdle.startWatching();
  }
  // For drawer Close on Logout
  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy() {
    if (this.notifyLogout) {
      this.notifyLogout.unsubscribe();
    }
  }

  /**
  * function for showing notification
  */
  showNotifications() {
    const drawerRefCreate = this.drawerService.create<NotificationsComponent, { newMessageCount: Number }, string>({
      nzTitle: 'Notifications',
      nzContent: NotificationsComponent,
      nzContentParams: {
        newMessageCount: this.newMessageCount,
      },
      nzWidth: '700px',
      nzClosable: true,
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
      },
    });
    drawerRefCreate.afterClose.subscribe(res => {
      this.getCountForNotifications()
    });
  }

  /**
* get notification count 
*/
  getCountForNotifications() {
    this.newMessageCount = 0;
    let count = 0;

    const userQuery = this.firestore.collection('merchant_users').doc(this.selectedUserId.toString()).ref;
    userQuery.onSnapshot((userSnapshot: any) => {
      if (userSnapshot.exists) {
        const user = userSnapshot.data();
        this.userNotificationTime = user.notificationTime;
      } else {
        this.newMessageCount = 0;
      }
    }, err => {
    });
    const nQuery = this.firestore.collection('merchant_users').doc(this.selectedUserId.toString()).collection('notifications').ref;
    nQuery.orderBy('createdDate', 'desc').onSnapshot(messageSnapshot => {
      if (messageSnapshot.docs.length > 0) {
        this.newMessageCount = 0;
        messageSnapshot.forEach(doc => {
          count++;
          const notifications = doc.data();
          if (notifications.createdDate > this.userNotificationTime) {
            this.newMessageCount = this.newMessageCount + 1;
          } else {

          }
        }, err => {

        });
      } else {
        this.newMessageCount = 0;
      }
    }, err => {

    });
  }

}

